import { ReturnTranslatedText } from '@wajeez-web/core/localization';

import { CollectionComponentTypeFormBuilder } from './CollectionComponentTypeFormBuilder';

interface CollectionComponentTypeCreateFormProps {
  onSubmit: (collectionComponentTypeId: number) => void;
  onCancel: () => void;
}

export const CollectionComponentTypeCreateForm = ({
  onSubmit,
  onCancel,
}: CollectionComponentTypeCreateFormProps) => {
  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Create New Type'}`}
          origintext="Create New Type"
        />
      </h1>
      <div className="mt-6">
        <CollectionComponentTypeFormBuilder
          type="Create"
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </div>
    </div>
  );
};
